var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrusted = function SvgTrusted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M28.992 5.764C21.386 5.821 15 1 15 1S8.614 5.822 1.008 5.764C1.008 5.764.195 25.979 15 29 29.805 25.98 28.992 5.764 28.992 5.764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m12.917 16.922 1.5 1.504 2.665-2.67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M18.506 22.407h-7.01a2.1 2.1 0 0 1-2.101-2.1v-8.182h11.211v8.181a2.1 2.1 0 0 1-2.1 2.1M15 6.46a3.515 3.515 0 0 0-3.515 3.515v2.12h7.03v-2.12A3.515 3.515 0 0 0 15 6.461"
  })));
};
export default SvgTrusted;